import { LivingSculpt } from '../components/LivingSculpt.js';

/**
 * Visual test harness for LivingSculpt. Query params control everything so
 * Playwright can drive arbitrary gens without code changes:
 *   ?gid=gen_xxx&idx=0&aspect=0.5625&suffix=openai-edit
 * Falls back to the molten whale local /ldi/ assets when no gid is provided.
 */
export function LdiTest() {
  const params = new URLSearchParams(window.location.search);
  const gid = params.get('gid');
  const idx = params.get('idx') ?? '0';
  const aspect = parseFloat(params.get('aspect') ?? '1');
  const suffix = params.get('suffix') ?? 'openai-edit';
  const src = gid
    ? `https://api.gilding.app/images/gen/${gid}/${suffix}-${idx}.png`
    : `/ldi/gen_0a1f5319649e6089e773cc29_cover.png`;
  const depthUrl = gid
    ? `https://api.gilding.app/images/depth/${gid}-${idx}.png`
    : `/ldi/gen_0a1f5319649e6089e773cc29_depth.png`;
  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#0a0810' }}>
      <LivingSculpt src={src} depthUrl={depthUrl} aspect={aspect} ambient motionHint={false} heightCap="86svh" alt="" />
    </div>
  );
}
